@use "@fukuri-admins/ui/layout" as *;

.Root {
  &__Title {
    text-align: center;
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 32px;
  }
  &__Description {
    font-size: 14px;
    color: $TextLabel;
    text-align: center;
  }
  &__Header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    align-items: center;

    &__Left {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__Right {
      color: $Text;
      &__Content {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: $LightGray;
        padding: 20px;
        border-radius: 8px;
        margin-bottom: 8px;
        &__Title {
          font-size: 12px;
          font-weight: bold;
        }
        &__Rate {
          font-weight: bold;
          text-align: center;
          &__Numerator {
            font-size: 24px;
          }
          &__Denominator {
            font-size: 15px;
          }
        }
        &__Button {
          background-color: unset;
          padding: 0;
        }
      }
    }
  }
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tableWrapper {
    margin-bottom: 16px;
  }
}
